import React from 'react';
import { useField } from 'react-final-form';
import { FormattedMessage } from 'react-intl';
import { generatePath, Link } from 'react-router';

import { PATH } from 'constants/RoutesConstants';
import { Card } from 'ui/base';

import Password from './formFields/Password';
import Username from './formFields/Username';
import LoginFooter from './LoginFooter';
import { Wrapper, Footer } from './UI';

/** @type {import('react-final-form').UseFieldConfig<'userName', string>} */
const useFieldConfig = { subscription: { value: true } };

/** @type React.FC */
const LoginForm = () => {
  const { value: username } = useField('userName', useFieldConfig).input;

  const path = generatePath(PATH.FORGOT_PASSWORD.path);
  return (
    <Wrapper layout="vertical">
      <Card title={<FormattedMessage id="login" defaultMessage="Login" />} variant="borderless">
        <Username />
        <Password />
        <Link to={path} data-cy="forgotten-password" state={{ username }}>
          <FormattedMessage id="page.login.forgotten_password" defaultMessage="Forgotten password ?" />
        </Link>
        <Footer>
          <LoginFooter />
        </Footer>
      </Card>
    </Wrapper>
  );
};

export default LoginForm;
